import { DEFAULT_MARKET, IN, ZA, AU } from '@clearscore/config.i18n';

export default {
    [IN]: {
        hasBurgerMenu: false,
        reportNotFoundHelpLink: 'https://in.help.clearscore.com/hc/en-us/articles/360012074360',
    },

    [ZA]: {
        reportNotFoundHelpLink: 'https://help.clearscore.co.za/hc/en-us/articles/360012074060',
    },

    [AU]: {
        reportNotFoundHelpLink: 'https://help.clearscore.com.au/hc/en-us/articles/360012074620',
    },

    [DEFAULT_MARKET]: {
        hasBurgerMenu: true,
        reportNotFoundHelpLink: 'https://help.clearscore.com/hc/en-us/articles/360012073620',
    },
};
